import { DateTimePreference } from "views/pages/symbol/module/dateTimePreference";
import { InputMeetingDateTimeProps, useInputITExplanationDateTime } from "./hooks";
import { Button, ButtonFill, ButtonSize, ButtonType } from "views/mutual/button";
import { SymbolPageStep } from "../../../hooks";
import { DomesticRealEstateSymbolDetailInfo } from "views/utils/graphql/graphql";
type ItDisclosureApplicationDateSelectionProps = {
    onClosed : (nextSymbolPageStep : SymbolPageStep, meetingDateTime? : Partial<InputMeetingDateTimeProps>) => void; 
    symbolDetail : DomesticRealEstateSymbolDetailInfo;
    today: Date;
}

export const ItDisclosureApplicationDateSelection = (props : ItDisclosureApplicationDateSelectionProps) => {
    const {formik, meetingDateTime1Props, meetingDateTime2Props, meetingDateTime3Props} = useInputITExplanationDateTime(props);
    return (
        <form onSubmit={formik.handleSubmit} className="itExplanation-modal_itDisclosureApplicationDateSelection">
            <div className='itExplanation-modal_itDisclosureApplicationDateSelection_wrapper'>
            <div className='itExplanation-modal_itDisclosureApplicationDateSelection_wrapper_title'>
                IT重説（オンライン）のお申込み
            </div>
            <div className='itExplanation-modal_itDisclosureApplicationDateSelection_wrapper_dateTimePreferenceGroup'>
            <DateTimePreference 
                title='第一希望'
                {...meetingDateTime1Props}
            />
            <DateTimePreference 
                title='第二希望'
                {...meetingDateTime2Props}
            />
            <DateTimePreference 
                title='第三希望'
                {...meetingDateTime3Props}
            />
            </div>

            <div className="itExplanation-modal_itDisclosureApplicationDateSelection_wrapper_description">
                <span>{'※ご相談は土日祝日を除く平日10時から17時までとさせていただきます。（年末年始等を除く）。'}</span>                
                <span>{'※ご希望に添えない場合は、あらためて日程調節のためご連絡を差し上げます。'}</span>                
            </div>
            <div className="itExplanation-modal_button">
                    <Button
                    type={ButtonType.Submit}
                    label={'IT重説の申込みに進む'}
                    buttonFill={ButtonFill.black}
                    buttonSize={ButtonSize.medium}
                    />
            </div>
            </div>
        </form>
    );
}
